"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.smartListFlashIcon = exports.smartListIconWrapper = exports.image = exports.wrapper = void 0;

var _util = require("../../../util");

const wrapper = ({
  cssProps,
  theme
}) => {
  const {
    variant = 'primary',
    backgroundColor
  } = cssProps;
  const variantTheme = theme.containedIcon[variant];
  return {
    background: (0, _util.color)(theme, backgroundColor ? "background.".concat(backgroundColor) : variantTheme.bg),
    borderRadius: variantTheme.borderRadius,
    boxShadow: (0, _util.boxShadow)(theme, variantTheme.boxShadow),
    height: variantTheme.size,
    width: variantTheme.size,
    position: 'relative'
  };
};

exports.wrapper = wrapper;

const image = () => ({
  maxWidth: '80%'
});

exports.image = image;

const smartListIconWrapper = ({
  theme
}) => ({
  position: 'absolute',
  backgroundColor: (0, _util.color)(theme, 'background.yellow'),
  borderRadius: '50%',
  top: -6,
  right: -6,
  width: 20,
  height: 20
});

exports.smartListIconWrapper = smartListIconWrapper;

const smartListFlashIcon = () => ({
  width: 12,
  height: 12
});

exports.smartListFlashIcon = smartListFlashIcon;
//# sourceMappingURL=ContainedIcon.style.js.map